import React from 'react';
import { Text, View } from 'react-native';
import { asterisk } from '../../utils/DictionaryManagementUtils';
import InputField from './InputField';
import { textSecondary_7_0 } from '../SimulatorsComponents/AuxiliaryComponent/TextComponent/TextStyle';

//= ========================================================================
const ManualInputField = ({
  key,
  globJSON,
  simPlatform,
  inputKey,
  iconGray,
  categoryText,
  inputText,
  isFormFilled,
  showIcon,
  isArrow,
}) => {
  const myStyle = {
    inputContainer: {
      marginBottom: 8,
    },
    inputHeadline: {
      marginBottom: 3,
      marginStart: 7,
    },
  };
  return (
    <View key={key} style={myStyle.inputContainer}>
      <Text style={[textSecondary_7_0(globJSON, simPlatform), myStyle.inputHeadline]}>
        {asterisk + categoryText}
      </Text>
      <InputField
        globJSON={globJSON}
        simPlatform={simPlatform}
        inputKey={inputKey}
        iconGray={iconGray}
        inputText={isFormFilled ? inputText : categoryText}
        isFormFilled={isFormFilled}
        showIcon={showIcon}
        isArrow={isArrow}
      />
    </View>
  );
};

export default ManualInputField;
